
import {merge as observableMerge,  Observable } from "rxjs";

import { Inject, Injectable } from "@angular/core";
import { filter, map } from "rxjs/operators";
import { ImmutableRedux } from "../../redux/immutable-redux.service";
import { FORM_CTAS_STATE_PROP, FORM_STATE_PROP } from "./state-props";

@Injectable()
export class FormActiveRef {
    public constructor(
        public ngRedux: ImmutableRedux<any>,
        @Inject(FORM_STATE_PROP) public formStateProp,
        @Inject(FORM_CTAS_STATE_PROP) public formCtasStateProp,
    ) { }

    public isFormActive$(stateProp: string): Observable<boolean> {
        return observableMerge(
            this.ngRedux.select(this.formStateProp, stateProp).pipe(
                filter((state) => state.formUI),
                map((state) => state.formUI.isVisible)),
            this.ngRedux.select(this.formCtasStateProp, stateProp).pipe(
                map((state) => state.isFormVisible)),
        );
    }
}
